import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { recoverPassword, clearAuthState } from "../redux/slices/authSlice";
import { Link, useNavigate } from "react-router-dom";
import logoiii from "../assets/logoiii.png";

const RecoverPassword = () => {
  const [email, setEmail] = useState("");
  const { loading, error, recoverySuccess } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(recoverPassword(email));
  };

  // Redirigir después de éxito
  useEffect(() => {
    if (recoverySuccess) {
      const timer = setTimeout(() => {
        navigate("/reset-password");
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [recoverySuccess, navigate]);

  // Limpiar estado al desmontar
  useEffect(() => {
    return () => {
      dispatch(clearAuthState());
    };
  }, [dispatch]);

  return (
    <div className="bg-gray-900 text-white relative min-h-screen w-full flex items-center justify-center font-montserrat  overflow-hidden py-12 sm:py-20"
      style={{
        background: "linear-gradient(to bottom, #1a1a1a 0%, #0d0d0d 100%)",
        overflow: "hidden",
      }}>
      <div className="absolute inset-0 z-0" style={{
        backgroundImage: `repeating-linear-gradient(90deg, transparent 0px, transparent 20px, #000000 20px, #000000 40px, transparent 40px, transparent 100px)`,
        backgroundSize: "100px 100%",
        boxShadow: "inset 0 0 10px rgba(0,0,0,0.8)",
      }} />
      <div className="absolute inset-0 z-0" style={{
        backgroundImage: `repeating-linear-gradient(90deg, transparent 0px, transparent 20px, rgba(0,0,0,0.5) 20px, rgba(0,0,0,0.5) 40px, transparent 40px, transparent 100px)`,
        backgroundSize: "100px 100%",
        filter: "blur(3px)",
        transform: "translateX(2px)",
      }} />
      <div className="p-4 sm:p-6 md:p-8 rounded-2xl w-full max-w-lg relative z-10 mt-16 sm:mt-20 md:mt-5"
        style={{
          border: "2px solid rgba(255, 255, 255, 0.7)",
          boxShadow: "0 0 20px rgba(255, 255, 255, 0.2)",
          background: "rgba(0, 0, 0, 0)",
          backdropFilter: "blur(5px)",
        }}>
        <div className="flex items-center justify-center mb-6">
          <img src={logoiii} alt="Logo" className="w-16 h-16 sm:w-24 sm:h-24 object-contain mr-2" />
          <span className="text-white font-bold text-lg sm:text-xl">EPIC MOVIE</span>
        </div>

        {recoverySuccess && (
          <div className="mb-4 p-3 bg-green-800 text-green-100 text-sm rounded">
            Se ha enviado un correo con instrucciones para recuperar tu contraseña. Serás redirigido en unos segundos...
          </div>
        )}
        
        {error && (
          <div className="mb-4 p-2 bg-red-900 text-red-200 text-sm rounded">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <label className="block text-sm font-medium text-white mb-2">Email</label>
          <input
            type="email"
            className="w-full p-2 md:p-3 bg-transparent border border-white/30 rounded-md text-white"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button
            type="submit"
            className="w-full mt-6 py-2 md:py-3 px-6 bg-yellow-400 text-black font-medium rounded-full transition-all duration-300 ease-in-out hover:bg-yellow-500 focus:outline-none focus:ring-4 focus:ring-yellow-300 focus:ring-opacity-50"
          >
            {loading ? "Enviando..." : "RECUPERAR CONTRASEÑA"}
          </button>
        </form>

        <p className="mt-4 text-center text-white">
          ¿Recordaste tu contraseña? <Link to="/" className="underline text-blue-500">Inicia sesión aquí</Link>
        </p>
      </div>
    </div>
  );
};

export default RecoverPassword;

// import React, { useState } from 'react';
// import axios from 'axios';
// import { Link, useNavigate } from 'react-router-dom';
// import logoii from "../assets/logoii.png";

// const API_URL = process.env.REACT_APP_API_URL;

// const RecoverPassword = () => {
//   const [email, setEmail] = useState('');
//   const [message, setMessage] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const navigate = useNavigate();
  
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');
//     setMessage('');
    
//     try {
//       const response = await axios.post(`${API_URL}/api/v1/auth/recover-password`, { email });
//       setMessage('Se ha enviado un correo con instrucciones para recuperar tu contraseña.');
//       setTimeout(() => {
//         navigate('/reset-password');
//       }, 3000);
      
//     } catch (err) {
//       setError(err.response?.data?.message || 'Ha ocurrido un error. Por favor, intenta nuevamente.');
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   return (
//     <div className="flex flex-col items-center min-h-screen justify-center bg-black">
//       <img src={logoii} alt="Logo de EPICMOVIE" className="w-24 h-24 mb-1" />
//       <h1 className="text-5xl font-bold text-white text-center drop-shadow-[0_0_10px_rgba(173,216,230,0.8)] shadow-lg font-montserrat">
//         EPIC
//       </h1>
//       <h1 className="text-5xl font-bold text-white text-center drop-shadow-[0_0_10px_rgba(173,216,230,0.8)] shadow-lg font-montserrat mb-5">
//         MOVIE
//       </h1>
      
//       <form 
//         onSubmit={handleSubmit}
//         className="bg-gray-800 p-8 rounded-lg shadow-md w-full max-w-sm"
//       >
//         {message && (
//           <div className="mb-4 p-2 bg-green-900 text-green-200 text-sm rounded">
//             {message} Serás redirigido en unos segundos...
//           </div>
//         )}
        
//         {error && (
//           <div className="mb-4 p-2 bg-red-900 text-red-200 text-sm rounded">
//             {error}
//           </div>
//         )}
        
//         <div className="mb-4">
//           <label
//             htmlFor="email-address"
//             className="block text-sm font-medium text-gray-300"
//           >
//             Email
//           </label>
//           <input
//             id="email-address"
//             name="email"
//             type="email"
//             autoComplete="email"
//             required
//             className="mt-1 block w-full px-3 py-2 border border-gray-600 rounded-md shadow-sm bg-gray-700 text-white focus:outline-none focus:ring-blue-500 focus:border-blue-500"
//             placeholder="Correo electrónico"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//           />
//         </div>
        
//         <button
//           type="submit"
//           disabled={loading}
//           className="w-full text-[#1a1f36]-600 py-3 px-6 border-2 border-[#1a1f36]-600 rounded-md transition-all duration-300 ease-in-out hover:bg-[#0f2027]-600 hover:text-white hover:border-[#1a1f36]-600 focus:outline-none focus:ring-4 focus:ring-[#0f2027]-500 focus:ring-opacity-50"
//         >
//           {loading ? "Enviando..." : "RECUPERAR CONTRASEÑA"}
//         </button>
//       </form>

//     </div>
//   );
// };

// export default RecoverPassword;